import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getMasterData } from "#/modules/generic.master-data/master-data.functions";
import { getSidebarPreferenceFn } from "#/modules/layout/sidebar.functions";

// Pathless guard layout (portal's _protected); the root already resolved the session into context.
export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated")({
  beforeLoad: ({ context, params, location }) => {
    if (!context.user) {
      // Carry the attempted URL via the `referer` param (portal's session authRedirect mechanism;
      // the Referer header doesn't survive TanStack's redirect, so we pass it explicitly — the
      // login loader stores it and loginCallback returns the user there after login).
      throw redirect({
        to: "/$locale/{-$schoolyear}/login",
        params: { locale: params.locale, schoolyear: params.schoolyear },
        search: { referer: location.href },
      });
    }
    // The page lives outside this layout, so this can't loop.
    if (!context.isAdmin && context.scholen.length === 0) {
      throw redirect({
        to: "/$locale/{-$schoolyear}/geen-school",
        params: { locale: params.locale, schoolyear: params.schoolyear },
      });
    }
    return { user: context.user };
  },
  // Global (not school-scoped) master-data, loaded at this shared ancestor so both the `$school`
  // tree and the school-less `admin` tree can consume it via `useMasterData()` (portal parity: RR7
  // loads it in `_protected`). Prevents the admin add/edit master-data forms from crashing.
  loader: async () => {
    const [masterData, sidebarPreference] = await Promise.all([
      getMasterData(),
      getSidebarPreferenceFn(),
    ]);
    return { masterData, sidebarPreference };
  },
  component: () => <Outlet />,
});
